<template lang="html">
  <d-card class="card-small mb-4">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" lg="4">
          <h6 class="m-0">Dados cadastrais</h6>
        </d-col>
        <d-col cols="12" lg="8" class="text-right" v-if="customer">
          <customer-buttons :customer="customer"></customer-buttons>
        </d-col>
      </d-row>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <customer-form ref="customerForm"/>
            <d-row>
              <d-col cols="12">
                <div class="control__button">
                  <d-button @click="save" class="btn-primary">Salvar</d-button>
                  <loader v-if="loading" :fullPage="false" class="ml-4"/>
                </div>
              </d-col>
            </d-row>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de cliente"
      message="Tem certeza que deseja excluir esse cliente?"/>
  </d-card>
</template>

<script>
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import CustomerForm from './CustomerForm.vue';
import CustomerDelete from './CustomerDelete';
import CustomerButtons from './CustomerButtons.vue';
import { _SAVE_CUSTOMER_SUCCESS_, _DELETE_CUSTOMER_ } from './CustomerModel';

export default {
  name: 'customer-page',
  mixins: [CustomerDelete],
  props: {
    customer: {
      type: Object,
      default: null,
    },
  },
  components: {
    Loader,
    CustomerForm,
    CustomerButtons,
    ConfirmationModal,
  },
  data() {
    return {
      loading: false,
      selectCustomer: null,
    };
  },
  computed: {},
  methods: {
    save() {
      this.$refs.customerForm.save();
      Events.$on(_SAVE_CUSTOMER_SUCCESS_, customer => {
        this.$router.push(`/admin/clientes/${customer.id}`);
      });
    },
  },
  destroyed() {
    Events.$off(_SAVE_CUSTOMER_SUCCESS_);
  },
  mounted() {
    Events.$on('loading', loading => {
      this.loading = loading;
    });
    Events.$on(_DELETE_CUSTOMER_, customer => {
      this.selectCustomer = customer.id;
    });
  },
};
</script>

<style lang="scss" scoped>
.control__button {
  display: flex;
  justify-content: flex-start;
}
</style>
